import 'css-chunk:src/app/containers/BudgetReporting/BudgetReportingContainer/components/budgetReportingPage/components/Tabs/tabs.scss';export default {
  "tabContainer": "_tabContainer_1ra3a_1",
  "tab": "_tab_1ra3a_1",
  "selectedTab": "_selectedTab_1ra3a_13"
};